/*@ngInject*/
const FieldRuleActionController = function ($element, $scope, localization, coreConstant, configurationMediator, uiFormTemplateModel) {
    $element.addClass('fieldRuleAction');

    this.selectFieldWidgetName = 'selectConditionalField';
    this.availableConditionalFieldList = [];
    this.selectedFields = '';
    this.thisForm = '';
    this.uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();

    localization.getTranslations().then(function (translations) {
        this.selectFieldsPrompt = _.get(translations, 'fieldRuleAction.selectFieldsPrompt');
        this.thisForm = _.get(translations, 'fieldRuleAction.thisForm');
    }.bind(this));

    this.getRuleNameSubstring = function () {
        var nameSubstring = this.fieldRule.name.lastIndexOf('-#') !== -1 ? this.fieldRule.name.substr(0, this.fieldRule.name.lastIndexOf('-#')) : this.fieldRule.name;
        return nameSubstring;
    };

    this.reset = function () {
        this.availableConditionalFieldList = [];
        this.selectedFields = '';
    };

    this.processAvailableConditionalFieldTemplates = function () {
        var existingAvailableConditionalField;

        _.each(this.fieldsInRule, function (fieldInRule) {
            existingAvailableConditionalField = _.find(this.availableConditionalFieldList, function (availableConditionalField) {
                return fieldInRule.id === parseInt(availableConditionalField.value);
            });
            if (_.isNil(existingAvailableConditionalField)) {
                this.availableConditionalFieldList.push({
                    name: fieldInRule.variableName,
                    value: fieldInRule.id.toString(),
                    grouping: 'Conditional Fields',
                    fieldTemplate: fieldInRule
                });
            }
            this.selectedFields += fieldInRule.id + '::';
        }.bind(this));
    };

    this.getAvailableConditionalFieldTemplateIds = _.debounce(function () {
        configurationMediator.getAvailableConditionalFieldTemplateIds(this.uiFormTemplate.id).then(function (result) {
            this.reset();
            _.each(result, function (fieldTemplateId) {
                _.each(this.uiFormTemplate.formTemplate.fieldTemplates, function (fieldTemplate) {
                    if (fieldTemplate.id === fieldTemplateId) {
                        this.availableConditionalFieldList.push({
                            name: fieldTemplate.variableName,
                            value: fieldTemplate.id.toString(),
                            grouping: 'Conditional Fields',
                            fieldTemplate: fieldTemplate
                        });
                    }
                }.bind(this));
            }.bind(this));
            this.processAvailableConditionalFieldTemplates();
        }.bind(this));
    }.bind(this), 500);

    this.$onInit = function () {
        this.getAvailableConditionalFieldTemplateIds();
    };

    this.$onChanges = function () {
        this.getAvailableConditionalFieldTemplateIds();
    };

    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, _.debounce(function (event, itemName) {
        var existingFieldInRule,
            conditionalFieldsNotInRule = [];
        if (itemName === this.selectFieldWidgetName) {
            _.each(this.availableConditionalFieldList, function (availableConditionalField) {
                if (!availableConditionalField.selected) {
                    availableConditionalField.fieldTemplate.triggerRuleName = null;
                    conditionalFieldsNotInRule.push(availableConditionalField.fieldTemplate);
                    _.remove(this.fieldsInRule, function (fieldInRule) {
                        return parseInt(availableConditionalField.value) === fieldInRule.id;
                    });
                } else {
                    existingFieldInRule = _.find(this.fieldsInRule, function (fieldInRule) {
                        return fieldInRule.id === parseInt(availableConditionalField.value);
                    });
                    if (_.isNil(existingFieldInRule)) {
                        availableConditionalField.fieldTemplate.triggerRuleName = this.getRuleNameSubstring();
                        this.fieldsInRule.push(availableConditionalField.fieldTemplate);
                    }
                }
            }.bind(this));
            this.selectedFields = '';
            this.processAvailableConditionalFieldTemplates();
            this.onFieldsInRuleUpdated({conditionalFieldsNotInRule: conditionalFieldsNotInRule});
        }
    }.bind(this)), 500);
};

angular.module('ums.configuration')
    .controller('fieldRuleActionController', FieldRuleActionController);
